import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { ReportSectionHeader } from "../SectionHeader";


const SCAProbabilityComponent = (props) => (
	<div>

		<ReportSectionHeader>
		 12-Month Probability of Rule 10b-5 Private Securities-Faud Class Action Lawsuit
		</ReportSectionHeader>

		<ReportTable
			settings={
			[
				{
					header: '', 
					accessor: 'SCAProbabilityRateLabel'
					
				},
				{
					header: 'Est. Annual Probability',
					accessor: 'SCAProbabilityRateValue',
					round1Decimal: true,
					percentageSign: true,
					percentageNumber: true,
					tooltip: 'Probability of a Rule 10b-5 suit being brought.'
				},
			]

			}
			data={props.SCAProbabilityRate}
			name={"SCAProbabilityRate"}

		/>
	</div>
);


export default SCAProbabilityComponent;



// WEBPACK FOOTER //
// ./src/common/components/SCAProbability/SCAProbabilityComponent.js